var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"btn-creative btn-3 btn-3e flaticon-plus",attrs:{"title":this.$root.trans.create,"to":{name: _vm.routeName}}},[_c('span',[_vm._v("إضافة جديد")])])
}
var staticRenderFns = []

export { render, staticRenderFns }